export const sliderFotos = [
  "/Images/Home/1.jpg",
  "/Images/Home/2.jpg",
  "/Images/Home/3.jpg",
  "/Images/Home/4.jpg",
  "/Images/Home/5.jpg",
  "/Images/Home/6.jpg",
  "/Images/Home/7.jpg",
  "/Images/Home/8.jpg",
  "/Images/Home/10.jpg",
  "/Images/Home/12.jpg",
  "/Images/Home/13.jpg",
  "/Images/Home/14.jpg",
  "/Images/Home/15.jpg",
  "/Images/Home/16.jpg",
  "/Images/Home/17.jpg",
  "/Images/Home/18.jpg",
  "/Images/Home/19.jpg",
  "/Images/Home/20.jpg",
  "/Images/Home/22.jpg",
  "/Images/Home/23.jpg",
  "/Images/Home/24.jpg",
  "/Images/Home/25.jpg",
  "/Images/Home/26.jpg",
  "/Images/Home/27.jpg",
  "/Images/Home/28.jpg",
  "/Images/Home/29.jpg",
  "/Images/Home/30.jpg",
  "/Images/Home/31.jpg",
  "/Images/Home/32.jpg",
  "/Images/Home/33.jpg",
  "/Images/Home/34.jpg",
  "/Images/Home/35.jpg",
  "/Images/Home/36.jpg",
  "/Images/Home/37.jpg",
  "/Images/Home/38.jpg",
  "/Images/Home/39.jpg",
  "/Images/Home/40.jpg",
  "/Images/Home/41.jpg",
  "/Images/Home/42.jpg",
  "/Images/Home/43.jpg",
  "/Images/Home/44.jpg",
  "/Images/Home/45.jpg",
  "/Images/Home/46.jpg",
  "/Images/Home/47.jpg",
  "/Images/Home/48.jpg"
];
